interface QuickStartStepProps {
  onUpload: () => void;
  onDemo: () => void;
}

export default function QuickStartStep({ onUpload, onDemo }: QuickStartStepProps) {
  return (
    <div className="w-full max-w-3xl mx-auto text-center">
      {/* Header */}
      <div className="mb-12">
        <div className="inline-flex items-center gap-2 bg-[#00D9FF]/10 border border-[#00D9FF]/30 text-[#00D9FF] text-xs font-semibold px-4 py-2 rounded-full uppercase tracking-widest mb-6" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
          <span className="w-1.5 h-1.5 rounded-full bg-[#00D9FF] animate-pulse inline-block" />
          무료 체험
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          몇 초 만에 첫 번째
          <br />
          <span className="text-[#00D9FF]">하이라이트 클립</span>을 만들어보세요
        </h1>
        <p className="text-gray-400 text-lg max-w-xl mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>
          영상을 업로드하거나 샘플 콘텐츠로 AI가 라이브 콘텐츠를
          <br />
          바이럴 클립으로 변환하는 과정을 직접 확인하세요
        </p>
      </div>

      {/* Two Options */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        {/* Upload Option */}
        <button
          onClick={onUpload}
          className="group relative bg-[#0F1419] border-2 border-white/10 hover:border-[#00D9FF]/60 rounded-2xl p-8 text-left transition-all duration-300 cursor-pointer overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#00D9FF]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <div className="relative z-10">
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-[#00D9FF]/15 mb-6 group-hover:bg-[#00D9FF]/25 transition-colors duration-200">
              <i className="ri-upload-cloud-2-line text-3xl text-[#00D9FF]" />
            </div>
            <h3 className="text-white font-bold text-xl mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              영상 파일 업로드
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              보유한 라이브 스트리밍 영상이나 녹화본을 업로드하면 AI가 즉시 분석합니다
            </p>
            <div className="flex flex-wrap gap-2">
              {["MP4", "MOV", "최대 500MB"].map((tag) => (
                <span key={tag} className="text-xs bg-white/5 border border-white/10 text-gray-400 px-2.5 py-1 rounded-full" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
          <div className="absolute bottom-4 right-4 w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <i className="ri-arrow-right-line text-[#00D9FF] text-lg" />
          </div>
        </button>

        {/* Demo Option */}
        <button
          onClick={onDemo}
          className="group relative bg-[#0F1419] border-2 border-white/10 hover:border-[#10B981]/60 rounded-2xl p-8 text-left transition-all duration-300 cursor-pointer overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#10B981]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          {/* Recommended Badge */}
          <div className="absolute top-4 right-4 bg-[#10B981]/20 border border-[#10B981]/40 text-[#10B981] text-xs font-semibold px-2.5 py-1 rounded-full" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
            추천
          </div>
          <div className="relative z-10">
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-[#10B981]/15 mb-6 group-hover:bg-[#10B981]/25 transition-colors duration-200">
              <i className="ri-play-circle-2-line text-3xl text-[#10B981]" />
            </div>
            <h3 className="text-white font-bold text-xl mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              데모 콘텐츠 체험
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              Riot Games e스포츠 방송 샘플로 AI 하이라이트 감지 기능을 즉시 체험해보세요
            </p>
            <div className="flex flex-wrap gap-2">
              {["47분 방송", "e스포츠", "즉시 시작"].map((tag) => (
                <span key={tag} className="text-xs bg-white/5 border border-white/10 text-gray-400 px-2.5 py-1 rounded-full" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
          <div className="absolute bottom-4 right-4 w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <i className="ri-arrow-right-line text-[#10B981] text-lg" />
          </div>
        </button>
      </div>

      {/* Social proof */}
      <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500" style={{ fontFamily: "'Inter', sans-serif" }}>
        {["회원가입 불필요", "평균 처리 시간 90초", "무제한 무료 체험"].map((item) => (
          <span key={item} className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-[#10B981] text-sm" />
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
